import { GridCellProps } from '@progress/kendo-react-grid';
import { useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import GridCellBase from '../GridCellBase';

const GLCodeMismatchCell = (props: GridCellProps) => {
  const { hasGlMismatchItems } = props.dataItem;
  const [cellClick] = useContext(EditCellContext);
  const { onGLCodeMismatchClick } = cellClick?.(null);

  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={true}
      title={hasGlMismatchItems}
      style={{
        backgroundColor: hasGlMismatchItems === 'Y' ? '#EFB2B2' : '#C3D7B9',
        textAlign: 'center',
      }}
    >
      <span>
        {hasGlMismatchItems}
        {hasGlMismatchItems === 'Y' && (
          <span
            title={'View Details'}
            className="k-icon k-i-comment cursor-pointer"
            onClick={(e) => {
              onGLCodeMismatchClick(props.dataItem);
              e.stopPropagation();
            }}
          />
        )}
      </span>
    </GridCellBase>
  );
};

export default GLCodeMismatchCell;
